import styled from "@emotion/styled";
import Colors from "/styles/colors";
import { WHITE_COLOR_NAME } from "styles/color-consts";
export const StyledWhatsNewMobileSecondFoldComponent = styled.div`
  padding: 0 0 48px 12px;

  .title-wrapper {
    margin: 40px 10px 20px;

    .core-title-container .core-title {
      font-size: 1.75rem;
      font-weight: 600;
    }
  }

  .carousel-wrapper .carousel .slick-slider .slick-dots {
    li button {
      background-color: ${Colors[WHITE_COLOR_NAME]};
      border: 1px solid;
      border-color: ${Colors.mud};
    }

    li.slick-active button {
      background-color: ${Colors.mud};
    }
  }

  .carousel-wrapper .carousel .slick-slider.focus .slick-list .slick-track .slick-slide .carousel-item {
    opacity: 1;
  }
`;
